export default "__VITE_ASSET__CZTjThyA__"